<template>
  <!-- /22832329239/Camfrog_p_160x600_DWEB -->
  <google-tag gpt-id="div-gpt-ad-1755541934118-0" />
</template>

<script>
import GoogleTag from "@/components/Ads/GoogleTag";

export default {
  name: "GoogleProfileVertical",
  components: { GoogleTag }
}
</script>

<style scoped>

</style>
